import React from 'react';
import { MdOutlineSupportAgent } from 'react-icons/md';

import { PrimaryButton } from 'lib/components';
import { theme } from 'lib/style';
import { Heading, ParagraphSmall } from 'lib/components/styles/typography';
import {
  MainWrapper,
  Union,
  ContentWrapper,
  BtnWrapper,
  ImageWrapper,
} from './styles';
import proCardImgReports from './not-connected.png';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components/macro';

const btnProps = {
  borderRadius: 6,
  height: '40px',
  fontSize: '15px',
  margin: '0px',
  textPadding: '8px 16px 8px 0px',
  width: 190,
  iconMargin: 0,
};

const mainBtn = {
  text: 'Go to your library',
  icon: <Union width={16} />,
  ...btnProps,
};

const contactBtn = {
  text: 'Contact Support',
  borderColor: '#00144e',
  icon: <MdOutlineSupportAgent width={16} />,
  ...btnProps,
};

type Props = {
  resetErrorBoundary?: (...args: Array<unknown>) => void;
  position?: 'relative' | 'fixed';
  style?: React.CSSProperties | undefined;
};

export const NotFound = ({
  resetErrorBoundary,
  position = 'relative',
  style,
}: Props) => {
  const history = useHistory();
  const themes = useTheme();
  return (
    <MainWrapper position={position} style={style}>
      <ContentWrapper>
        <Heading color={theme.palette.primaryDarkBlue}>
          Oops! Something’s not right...
        </Heading>
        <BtnWrapper>
          <PrimaryButton
            onClick={() =>
              resetErrorBoundary ? resetErrorBoundary() : history.push('/home')
            }
            textColor={themes.colors.primaryButtonTextColor}
            iconColor={themes.colors.primaryButtonTextColor}
            iconOpacity={1}
            {...mainBtn}
          />
          <ParagraphSmall color='#9297a2'>or</ParagraphSmall>
          <a style={{ textDecoration: 'none' }} href='tel:+1800.306.1445'>
            <PrimaryButton
              onClick={() => null}
              backgroundColor={themes.colors.secondaryButtonBgColor}
              {...contactBtn}
            />
          </a>
        </BtnWrapper>
      </ContentWrapper>
      <ImageWrapper>
        <img alt='not connected' src={proCardImgReports} />
      </ImageWrapper>
    </MainWrapper>
  );
};
